// extracted by mini-css-extract-plugin
export var borderRadius = "_6s-4";
export var large = "_6s-3";
export var logoContainer = "_6s-0";
export var nameLogo = "_6s-2";
export var small = "_6s-1";